import { Box, Typography } from "@mui/material";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";

import SiteIcons from "@/components/SiteIcons/SiteIcons";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

import "@/components/ProgressSteps/ProgressSteps.css";

const membershipDataSteps = [
  {
    smallLabel: "Step 1",
    bigLabel: "Select File",
    location: "/membership/update-data/select-file",
  },
  {
    smallLabel: "Step 2",
    bigLabel: "Choose Template",
    location: "/membership/update-data/choose-template",
  },
  {
    smallLabel: "Step 3",
    bigLabel: "Map Template",
    location: "/membership/update-data/edit-template",
  },
  {
    smallLabel: "Step 4",
    bigLabel: "Preview File",
    location: "/membership/update-data/preview-file",
  },
  {
    smallLabel: "Step 5",
    bigLabel: "Processing Confirmed",
    location: "/membership/update-data/processing-confirmed",
  },
];

const politicalDataSteps = [
  {
    smallLabel: "Step 1",
    bigLabel: "Select File",
    location: "/political/update-data/select-file",
  },
  {
    smallLabel: "Step 2",
    bigLabel: "Map Template",
    location: "/political/update-data/map-template",
  },
  {
    smallLabel: "Step 3",
    bigLabel: "Confirmation",
    location: "/political/update-data/confirmation",
  },
];

export default function ProgressSteps() {
  const [activeStep, setActiveStep] = useState(0);
  const [steps, setSteps] = useState(membershipDataSteps);
  const { workflow } = useUpdateDataContext();
  const location = useLocation();

  useEffect(() => {
    if (workflow === "political") {
      setSteps(politicalDataSteps);
    } else {
      setSteps(membershipDataSteps);
    }
  }, [workflow]);

  useEffect(() => {
    const index = steps.findIndex(
      (step) => step.location === location.pathname
    );
    setActiveStep(index);
  }, [location, steps]);

  return (
    <Box className="progress-steps-container-outer">
      <Box className="progress-steps-container-inner">
        <Stepper activeStep={activeStep}>
          {steps.map((step, index) => {
            return (
              <Step key={step.smallLabel} className="individual-step">
                <div>
                  {index < activeStep ? (
                    <SiteIcons
                      iconstring="check"
                      page="step-label-icon completed-step-icon"
                    />
                  ) : index === activeStep ? (
                    <SiteIcons
                      iconstring="radio-button-checked"
                      page="step-label-icon active-step-icon"
                    />
                  ) : (
                    <SiteIcons
                      iconstring="circle"
                      page="step-label-icon future-step-icon"
                    />
                  )}
                </div>
                <div>
                  <Typography variant="caption">{step.smallLabel}</Typography>
                  <Typography variant="body1">{step.bigLabel}</Typography>
                </div>
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </Box>
  );
}
